<template>
  <div class="cp-set-phone-number main">
    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-phone icon" />Shop Phone Number</p>
      <div style="margin-top: 10px">
        <input
          class="input"
          v-model="shopPhoneNumber"
          placeholder="+66123456789"
        />
      </div>
      <p class="hint">
        Customers will contact you here if they need to call about an order.
      </p>
      <div class="save-wrapper">
        <p v-if="updatingShopNumber" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveShopNumber">
          Save
        </p>
      </div>
    </div>

    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-briefcase icon" />Boss Phone Number</p>
      <div style="margin-top: 10px">
        <input
          class="input"
          v-model="bossPhoneNumber"
          placeholder="+66123456789"
        />
      </div>
      <p class="hint">
        TUK will contact you here if we need to help you or speak to the person
        in charge.
      </p>
      <div class="save-wrapper">
        <p v-if="updatingBossNumber" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveBossNumber">
          Save
        </p>
      </div>
    </div>

    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-globe-asia icon" />Country Code</p>
      <p class="hint">
        You may see phone numbers with the appropriate country code given your
        shop location:
        <span class="has-text-weight-medium">{{ countryCode }}</span>
      </p>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetPhoneNumber",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      shopPhoneNumber: null,
      bossPhoneNumber: null,
      updatingShopNumber: false,
      updatingBossNumber: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    languages() {
      return this.commerce.data.languages || ["en", "th"]; // otherwise show default languages...
    },
    countryCode() {
      var country = this.business.country;
      switch (country) {
        case "th":
          return "+66";
        case "sg":
          return "+65";
        case "jp":
          return "+81";
        case "pt":
          return "+351";
        default:
          return "+66";
      }
    },
  },
  mounted() {
    this.shopPhoneNumber = this.business.data.phone_number;
    this.bossPhoneNumber = this.business.data.boss_phone_number;
  },
  methods: {
    parsePhoneNumber(raw) {
      if (this.business.country !== "th") return raw; // skip if not thailand
      if (raw[0] === "0") {
        return `+66${raw.substring(1, raw.length)}`; // probably local thai number like 0909588716
      }
      if (raw.substring(0, 4) === "+660") {
        return `+66${raw.substring(4, raw.length)}`; // thai number with extra 0
      }
      if (raw[0] === "+") {
        return raw; // could be correct international number
      }
      return raw; // otherwise let it through as-sis
    },
    validNumber(str) {
      // var clean = str.replace(/\D/g,''); // strips all non-numerics
      if (!str || str.length < 8) {
        var msg = "Phone number too short";
        this.errorToast(msg, "top");
        return false;
      }
      if (isNaN(str)) {
        msg = "Phone number invalid";
        this.errorToast(msg, "top");
        return false;
      }
      return true;
    },
    saveShopNumber() {
      if (!this.validNumber(this.shopPhoneNumber)) return;
      var phoneNumber = this.parsePhoneNumber(this.shopPhoneNumber);
      var obj = { phone_number: phoneNumber };
      this.updatingShopNumber = true;
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj, //phone_number: phoneNumber,
        })
        .then((res) => {
          this.successToast("Updated");
          this.business.data = res.data.data; // this.business.phone_number = phoneNumber;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingShopNumber = false));
    },
    saveBossNumber() {
      if (!this.validNumber(this.bossPhoneNumber)) return;
      var phoneNumber = this.parsePhoneNumber(this.bossPhoneNumber);
      var obj = { boss_phone_number: phoneNumber };
      this.updatingBossNumber = true;
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated");
          this.business.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingBossNumber = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.hint {
  margin-top: 6px;
  margin-left: 4px;
  color: grey;
  font-size: 0.9em;
}
</style>
